export class Faq {
    title: string;
    order: number;
    answers: FaqAnswer[];

    constructor() {}
}

export class FaqAnswer {
    type: string;
    order: number;
    body: string;

    constructor() {}
}